/* eslint-disable react-hooks/exhaustive-deps */
// -- == //
import { SetStateAction, useEffect, useState } from 'react';
import { Formik } from 'formik';

import SecundButton from 'components/form/buttons/secundButton';
import MiniPopUp from 'components/modal/miniPopUp';
import PanelBoxLayout from 'components/layout/panelBox';
// import { useActions } from "common/hooks/useActions";

import Gap from 'components/gap';
import PrimaryButton from 'components/form/buttons/primaryButton';
import { useActions } from 'common/hooks/useActions';
import DropDown from 'components/form/dropDown';
import OutlineButton from 'components/form/buttons/outLineButton';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  setFilter: SetStateAction<any>;
  filter: any;
  roles: string[];
}

export default function AdminFilterPopup({ setFilter, filter, roles }: IProps) {
  const [flag, setFlag] = useState<number>(0);

  const { areaListRequestAction, rolesRequestAction } = useActions();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    areaListRequestAction();
    rolesRequestAction();
  };

  return (
    <S.Content>
      <MiniPopUp
        popUpStyle={{ width: 280, padding: '0' }}
        buttonNode={
          <SecundButton
            hasIcon={true}
            icon="/icons/stroke/filter.svg"
            iconStyle={{ background: 'none' }}
            className="secondary"
          >
            Filters
          </SecundButton>
        }
        key={flag}
      >
        <PanelBoxLayout className="bare" title="Filters" icon="/icons/stroke/filter.svg">
          <Formik
            initialValues={{
              role: ['sAdmin', 'admin', 'supporter', 'cafeTeriaManager'],
              roleTitle: ''
            }}
            // validationSchema={ValidationLogin}
            onSubmit={(values, { setSubmitting }) => {
              setFilter({
                ...filter,
                role: values.role,
                page: 1
              });
              setSubmitting(false);
              setFlag((val) => (val += 1));
            }}
          >
            {({
              values,
              errors,
              touched,
              // handleChange,
              handleSubmit,
              // isSubmitting,
              resetForm,
              setValues
            }) => (
              <>
                <DropDown
                  label="Role"
                  list={roles?.map((item: any) => {
                    return { id: item, title: item };
                  })}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      role: [e.id] as any,
                      roleTitle: e.id as any
                    });
                  }}
                  defaultValue={{
                    id: values.roleTitle,
                    title: values.roleTitle
                  }}
                  placeholder="Select Role"
                  message={touched.roleTitle && (errors.roleTitle as any)}
                  error={errors.role as unknown as boolean}
                />

                <Gap size="20px" />

                <PrimaryButton
                  onClick={handleSubmit}
                  // disabled={isSubmitting}
                  style={{ width: '100%' }}
                >
                  Filter
                </PrimaryButton>
                <Gap size="10px" />

                <OutlineButton
                  onClick={() => {
                    setValues({
                      role: ['sAdmin', 'admin', 'supporter', 'cafeTeriaManager'],
                      roleTitle: ''
                    });
                    handleSubmit();
                  }}
                  // disabled={isSubmitting}
                  style={{ width: '100%' }}
                >
                  Reset
                </OutlineButton>
              </>
            )}
          </Formik>
        </PanelBoxLayout>
      </MiniPopUp>
    </S.Content>
  );
}
